module.exports = __webpack_public_path__ + "static/img/9.e4267da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/sp/9.png
// module id = j+25
// module chunks = 0